export class DetailsConstants {
    public static readonly LOCK_TOOLTIP_FULL_UNLINKED = 'This order is locked for editing.';

    public static readonly LOCK_TOOLTIP_PARTIAL_REPORT_ADDENDA =
        'This order has a completed report and is partially locked for editing. You can upload documents and priors.';
    public static readonly LOCK_TOOLTIP_PARTIAL_ON_HOLD =
        'This order is assigned and is partially locked for editing. You can upload documents and priors.';

    public static readonly LOCK_TOOLIP_FULL_ASSIGNED = 'This order is assigned and locked for editing.';
    public static readonly LOCK_TOOLTIP_FULL_REPORTED = 'This order has a completed report and is locked for editing.';
}
